export default "__VITE_ASSET__b6d9ec6f__"